import React from 'react';

export const name = 'flag-RO';

export const FlagRO = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_395)">
      <mask
        id="mask0_2_395"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_395)">
        <path
          d="M12 2.8954e-09C10.5328 2.8954e-09 9.12656 0.2625 7.82812 0.75L0.421875 12L7.82812 23.25C9.16308 23.7462 10.5758 24.0001 12 24C13.4672 24 14.8734 23.7375 16.1719 23.25L23.5781 12L16.1719 0.75C14.8369 0.253946 13.4242 -3.13118e-05 12 2.8954e-09Z"
          fill="#FFDA44"
        />
        <path
          d="M24 12C23.9997 9.54989 23.2494 7.15861 21.85 5.14748C20.4506 3.13636 18.4691 1.60179 16.1719 0.75V23.25C18.4691 22.3982 20.4506 20.8636 21.85 18.8525C23.2494 16.8414 23.9997 14.4501 24 12Z"
          fill="#D80027"
        />
        <path
          d="M7.82813 23.25V0.75C5.53158 1.60243 3.55097 3.13728 2.15231 5.14838C0.753641 7.15941 0.00395203 9.55036 0.00395203 12C0.00395203 14.4496 0.753641 16.8406 2.15231 18.8516C3.55097 20.8627 5.53158 22.3976 7.82813 23.25Z"
          fill="#0052B4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_395">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
